export const MAX_ALLOWED_IMAGES = 64;

export const EDIT_IMAGES_BUTTON_TEXT = 'Select Images';

export const NO_IMAGES_SELECTED_TEXT =
  'No images selected. Add images to your business profile by clicking the "Edit images" button.';

export const ALL_IMAGES_FILTERED =
  'No images found matching your current filters. Try adjusting your search or clearing the filters.';
